import { FaInfoCircle } from 'react-icons/fa'
import { Flex, Box, Text } from 'theme-ui'

export function AttachmentsNote() {
  return (
    <Flex py={3}>
      <Box sx={{ flex: 1, maxWidth: 30 }}>
        <FaInfoCircle size={20} />
      </Box>
      <Flex sx={{ flexDirection: 'column' }}>
        <Text sx={{ fontSize: 15, fontWeight: 'bold' }}>CATATAN:</Text>
        <Text sx={{ fontSize: 13 }}>- Ukuran tiap file maksimal: 20MB</Text>
        <Text sx={{ fontSize: 13 }}>- Ukuran total file maksimal: 100MB</Text>
        <Text sx={{ fontSize: 13 }}>
          - Format file yang dikirimkan: zip | doc | docx | pdf | jpg | png |
          rar | mp3 | mp4 | gif | ppt | pptx | mov | 3gp
        </Text>
      </Flex>
    </Flex>
  )
}

export function Terms() {
  return (
    <Flex>
      <Box sx={{ flex: 1, maxWidth: '45px' }}>
        <FaInfoCircle size={28} />
      </Box>
      <Flex sx={{ flex: 1, flexDirection: 'column' }}>
        <Text sx={{ fontSize: 16, fontWeight: '700' }}>
          Syarat dan Ketentuan
        </Text>
        <Text sx={{ fontSize: 14, fontWeight: 'bold' }}>
          Hanya pengaduan yang memenuhi kriteria yang akan kami proses lebih
          lanjut, sebagai salah satu tanda keseriusan pengaduan silahkan
          melampirkan data pendukung yang memadai. Dengan klik Kirim, berarti
          Anda telah setuju pada syarat dan ketentuan yang berlaku pada Murai
          Whistle Blowing System.
        </Text>
      </Flex>
    </Flex>
  )
}
